import * as TK from 'components/profile/ManageGivingLinkForm/translations/constants';
import { Translations } from 'translations/types';

export const manageGivingLinkFormEnUsLocale: Translations = {
  [TK.MANAGE_GIVING_LINK_FORM_LINK_FIELD_PLACEHOLDER]: 'Set/Update your giving link',
  [TK.MANAGE_GIVING_LINK_FORM_INVALID_URL_ERROR_MESSAGE]: 'Link is invalid.',
  [TK.MANAGE_GIVING_LINK_FORM_CANCEL_BUTTON_LABEL]: 'Cancel',
  [TK.MANAGE_GIVING_LINK_FORM_SUBMIT_BUTTON_LABEL]: 'Save',
};
